export default __webpack_public_path__ + "static/port-4-6672a1d80d1d95a1a3109ec235af322e.jpeg";